import React, { createContext, ReactNode } from "react";

type analytics = {
  track: Function;
};

type AnalyticsProps = {
  children: ReactNode;
};

const defaultAnalytics: analytics = {
  track: (action: string, options: any): void => {
    // @ts-ignore
    gtag("event", action, options);
  },
};
export const AnalyticsContext = createContext(defaultAnalytics);

export const AnalyticsProvider: React.FunctionComponent<{
  children: ReactNode;
}> = ({ children }) => (
  <AnalyticsContext.Provider value={defaultAnalytics}>
    {children}
  </AnalyticsContext.Provider>
);

export default AnalyticsProvider;
